import Icon from 'veui/components/Icon'

Icon.register({
  'chevron-left': {
    paths: [
      {
        d: 'M13.83 24L34.4 3.41A2 2 0 0031.6.6l-22 22a2 2 0 000 2.82l22 22a2 2 0 102.82-2.82L13.83 24z'
      }
    ],
    width: '48',
    height: '48'
  }
})
